import { error } from "jquery";

export default {
    server: {
        fatal: {
            title  : "Anwendungsfehler",
            message: "Der LM 4 Server konnte die Anfrage nicht ausführen. Der Fehler wurde protokolliert und wird zeitnah korrigiert."
        }
    },

    rules: {
        required: "Eingabe erforderlich",
    },

    common: {
        yes     : "Ja",
        no      : "Nein",
        cancel  : "Abbrechen",
        store   : "Speichern",
        close   : "Schliessen",
        delete  : "Löschen",
        stored  : "Die Daten wurden gespeichert.",
        refresh : "Aktualisieren",
        required: "Eingabe erforderlich!",
        loading : "Gleich geht's weiter ...",
        newVersion: {
            title  : "Neue Version verfügbar",
            message: "Bitte laden Sie die Seite neu, um die aktuelle Version von LM 4 zu verwenden. Ungespeicherte Eingaben gehen dabei verloren.",
            reload : "Neu laden"
        },
        error  : {
            title  : "Fehler",
            generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support."
        }
    },

    home: {
        button: "Home"
    },

    movements: {
        title: "Letzte Bewegungen"
    },

    welcome: {
        title: "Willkommen beim Liftmanager 4.0",
        info : "Bevor die Arbeit mit dem Liftmanager 4.0 beginnen kann, muss der Zugang zum ELO System sichergestellt werden. Gib hierzu bitte Deine Zugangsdaten ein. Die Daten werden im Liftmanager 4.0 verschlüsselt gespeichert. Über den Dialog Einstellungen kann das Passwort später jederzeit wieder geändert werden."
    },

    search: {
        site: {
            result: "Anlagen",
        },
        incident: {
            result: "Ereignisse",
        }
    },

    navtop: {
        recent: {
            incident: "Zuletzt bearbeitete Ereignisse",
            site    : "Zuletzt angezeigte Anlagen"
        },

        search: {
            hits  : " Treffer",
        },
    },

    top: {
        site: {
            location: "{0}, {1} {2}",
            title   : "Fabrik-Nr. {0} - {1}",
            detail  : {
                manufacturer     : "Hersteller: {0}",
                rebuildingcompany: "Umbaufirma: {0}"
            },

            contacts: {
                row: {
                    customer   : "Ansprechpartner",
                    onsite     : "Ansprechpartner vor Ort",
                    maintenance: "Wartungsnehmer",
                    emergency  : "Notrufnehmer",
                    certificate: "ZÜS"
                }
            }
        }
    },

    site: {
        pagination: {
            info: "{0} bis {1} von insgesamt {2} Anlagen"
        }
    },

    administration: {
        exchange: {
            from    : "von Datum",
            to      : "bis Datum",
            subject : "Betreff",
            run     : "Emails importieren",
            store   : "Meldungen speichern",
            move    : "Meldungen in Archiv verschieben",
            execute : "Der Import wurde gestartet!",
            finished: "Der Import wurde abgeschlossen!",
            selectall: "Alle Kunden auswählen"
        }
    },

    image: {
        category: {
            common: "Bildarchiv",
            image : "Fotos",
            book  : "Prüfbuch",
            lgs   : "LG Smart"
        }
    },

    utils: {
        pdfviewer: {
            button: {
                prev    : "Zur vorherigen Seite blättern",
                next    : "Zur nächsten Seite blättern",
                zoomin  : "Vergrössern",
                zoomout : "Verkleinern",
                fit     : "Größe anpassen",
                download: "PDF herunterladen"
            }
        }
    },

    badge: 'Abzeichen',
    close: 'Schließen',
    dataIterator: {
        noResultsText: 'Keine Elemente gefunden',
        loadingText: 'Lade Elemente...',
    },
    dataTable: {
        itemsPerPageText: 'Zeilen pro Seite:',
        ariaLabel: {
            sortDescending: 'Absteigend sortiert.',
            sortAscending: 'Aufsteigend sortiert.',
            sortNone: 'Nicht sortiert.',
            activateNone: 'Aktivieren um Sortierung zu entfernen.',
            activateDescending: 'Aktivieren um absteigend zu sortieren.',
            activateAscending: 'Aktivieren um aufsteigend zu sortieren.',
        },
        sortBy: 'Sortiere nach',
    },
    dataFooter: {
        itemsPerPageText: 'Elemente pro Seite:',
        itemsPerPageAll: 'Alle',
        nextPage: 'Nächste Seite',
        prevPage: 'Vorherige Seite',
        firstPage: 'Erste Seite',
        lastPage: 'Letzte Seite',
        pageText: '{0}-{1} von {2}',
    },
    datePicker: {
        itemsSelected: '{0} ausgewählt',
        nextMonthAriaLabel: 'Nächsten Monat',
        nextYearAriaLabel: 'Nächstes Jahr',
        prevMonthAriaLabel: 'Vorheriger Monat',
        prevYearAriaLabel: 'Vorheriges Jahr',
    },
    noDataText: 'Keine Daten vorhanden',
    carousel: {
        prev: 'Vorheriges Bild',
        next: 'Nächstes Bild',
        ariaLabel: {
            delimiter: 'Element {0} von {1}',
        },
    },
    calendar: {
        moreEvents: '{0} mehr',
    },
    fileInput: {
        counter: '{0} Dateien',
        counterSize: '{0} Dateien ({1} gesamt)',
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
    },
    pagination: {
        ariaLabel: {
            wrapper    : 'Seitennavigation',
            next       : 'Nächste Seite',
            previous   : 'Vorherige Seite',
            page       : 'Gehe zu Seite {0}',
            currentPage: 'Aktuelle Seite, Seite {0}',
        },
    },

    input: {
        clear: "",
        appendAction: ""
    },

    enums: {
        unitStateTypes: {
            NORMAL         : "in Betrieb",
            STANDSTILL     : "Stillstand",
            LONG_STANDSTILL: "Stillstand > 1 Tag",
            UNKNOWN        : "keine Sensordaten",
            CREATED        : "neu angelegt",
        },
    },
}
